import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { QrCode, CheckCircle, ArrowRight } from 'lucide-react';

const Barcode = () => {
  const features = [
    '1D and 2D barcode support',
    'High-speed scanning devices',
    'Wireless and handheld scanners',
    'Integration with existing systems',
    'Batch scanning capabilities',
    'Error detection and validation',
    'Real-time data capture',
    'Rugged industrial devices',
    'Custom label printing',
    'Multi-platform compatibility'
  ];

  return (
    <div className="min-h-screen bg-slate-50">
      <section className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-16 px-4">
        <div className="container mx-auto max-w-7xl">
          <div className="flex items-center justify-center mb-6">
            <QrCode className="w-16 h-16 text-cyan-400" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center">Barcode Scanning Solutions</h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto text-center">
            Efficient and accurate barcode scanning for streamlined operations
          </p>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="container mx-auto max-w-7xl">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">Fast, Accurate Data Capture</h2>
            <p className="text-lg text-slate-600">
              Our barcode scanning solutions provide fast, accurate, and reliable data capture for your warehouse and field operations. From handheld devices to fixed scanners, we offer a complete range of barcode scanning technology tailored to your needs.
            </p>
          </div>

          <div className="mb-16">
            <h3 className="text-2xl font-bold text-slate-900 mb-8 text-center">Key Features</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start space-x-3 bg-white p-4 rounded-lg shadow-sm">
                  <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-gradient-to-br from-cyan-600 to-blue-600 text-white">
        <div className="container mx-auto max-w-4xl text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Upgrade Your Scanning Technology</h2>
          <p className="text-xl mb-8 text-cyan-100">
            Let us help you choose the right barcode solution
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-white text-cyan-600 hover:bg-slate-100 px-8 py-6 text-lg transition-all duration-300 hover:scale-105">
              Get Started <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Barcode;